function FreespaceError(response, json) {
  this.name = 'FreespaceError';

  //@todo create a proper error message after looking at a sample API response
  this.message = json ? json.error : response.statusText || 'Unknown Error';
  this.stack = (new Error()).stack;

  this.status = response.status;
  this.url = response.url;

}
FreespaceError.prototype = Object.create(Error.prototype);
FreespaceError.prototype.constructor = FreespaceError;

export default FreespaceError;
